(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fcm-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (!root || root.dataset.fcmFaqReady) return;
      root.dataset.fcmFaqReady = 'true';

      root.querySelectorAll('[data-fcm-faq-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-fcm-faq-item]');
          if (!item) return;

          var panel = item.querySelector('[data-fcm-faq-panel]');
          var isOpen = item.classList.contains('is-open');

          // Close all items in this section (accordion behavior)
          root.querySelectorAll('[data-fcm-faq-item]').forEach(function (other) {
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('[data-fcm-faq-trigger]');
            var otherPanel = other.querySelector('[data-fcm-faq-panel]');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.hidden = true;
          });

          // Toggle the clicked item
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            if (panel) panel.hidden = false;
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-fcm-faq]').forEach(initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) {
        var section = e.target.querySelector('[data-fcm-faq]') || (e.target.matches('[data-fcm-faq]') ? e.target : null);
        if (section) {
          delete section.dataset.fcmFaqReady;
          initFaq(section);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fcm-header-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatMoney(cents, root) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = (Number(cents) / 100).toFixed(2);
      var panel = root && root.querySelector ? root.querySelector('.fcm-cart-drawer__panel') : null;
      var moneyFormat = panel ? panel.getAttribute('data-money-format') : null;
      var currency = panel ? panel.getAttribute('data-currency') : 'USD';

      if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || 'USD'
        }).format(Number(cents) / 100);
      } catch (e) {
        return '$' + value;
      }
    }

    function fetchCart() {
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) { return r.json(); });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-fcm-cart-count]').forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    function renderCart(cart, root) {
      var body = root.querySelector('[data-fcm-cart-body]');
      var footer = root.querySelector('[data-fcm-cart-footer]');
      var subtotal = root.querySelector('[data-fcm-cart-subtotal]');
      if (!body) return;

      updateCartCount(cart.item_count || 0);

      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<p class="fcm-cart-drawer__empty">Your cart is empty.</p>';
        if (footer) footer.setAttribute('hidden', '');
        return;
      }

      var html = cart.items.map(function (item) {
        var img = item.image
          ? '<img class="fcm-cart-drawer__item-img" src="' + item.image + '" alt="" width="72" height="72" loading="lazy">'
          : '<div class="fcm-cart-drawer__item-img fcm-cart-drawer__item-img--placeholder">IMAGE</div>';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="fcm-cart-drawer__item-meta">' + item.variant_title + '</p>'
          : '';
        return (
          '<div class="fcm-cart-drawer__item" data-line-key="' + item.key + '">' +
            img +
            '<div>' +
              '<p class="fcm-cart-drawer__item-title">' + item.product_title + '</p>' +
              variant +
              '<div class="fcm-cart-drawer__item-row">' +
                '<div class="fcm-cart-drawer__qty">' +
                  '<button type="button" data-fcm-qty="-1" aria-label="Decrease quantity">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-fcm-qty="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<span class="fcm-cart-drawer__item-price">' + formatMoney(item.final_line_price, root) + '</span>' +
              '</div>' +
              '<button type="button" class="fcm-cart-drawer__remove" data-fcm-remove>Remove</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      body.innerHTML = html;
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price, root);
      if (footer) footer.removeAttribute('hidden');
    }

    function openCart(drawer, trigger) {
      drawer.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      fetchCart().then(function (cart) {
        renderCart(cart, drawer);
      }).catch(function () {
        var body = drawer.querySelector('[data-fcm-cart-body]');
        if (body) body.innerHTML = '<p class="fcm-cart-drawer__empty">Unable to load cart.</p>';
      });
    }

    function closeCart(drawer, trigger) {
      drawer.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function syncHeaderSpacer(root) {
      var section = root.closest('.shopify-section') || root.parentElement;
      var spacer = section ? section.querySelector('[data-fcm-header-spacer]') : document.querySelector('[data-fcm-header-spacer]');
      if (!spacer || !root) return;
      var height = root.offsetHeight || 64;
      spacer.style.height = height + 'px';
      document.documentElement.style.setProperty('--fcm-header-height', height + 'px');
    }

    function initHeader(root) {
      if (!root || root.dataset.fcmHeaderReady) return;
      root.dataset.fcmHeaderReady = 'true';

      var section = root.closest('.shopify-section') || root.parentElement;
      var burger = root.querySelector('[data-fcm-header-burger]');
      var menuDrawer = root.querySelector('[data-fcm-header-drawer]');
      var cartDrawer = section ? section.querySelector('[data-fcm-cart-drawer]') : document.querySelector('[data-fcm-cart-drawer]');
      var cartOpenBtns = root.querySelectorAll('[data-fcm-cart-open]');

      syncHeaderSpacer(root);
      window.addEventListener('resize', function () {
        syncHeaderSpacer(root);
      });

      if (burger && menuDrawer) {
        burger.addEventListener('click', function () {
          var isOpen = !menuDrawer.hasAttribute('hidden');
          if (isOpen) {
            menuDrawer.setAttribute('hidden', '');
            burger.setAttribute('aria-expanded', 'false');
            burger.setAttribute('aria-label', 'Open menu');
          } else {
            menuDrawer.removeAttribute('hidden');
            burger.setAttribute('aria-expanded', 'true');
            burger.setAttribute('aria-label', 'Close menu');
          }
        });
      }

      if (cartDrawer) {
        cartOpenBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            openCart(cartDrawer, btn);
          });
        });

        cartDrawer.querySelectorAll('[data-fcm-cart-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            closeCart(cartDrawer, cartOpenBtns[0]);
          });
        });

        cartDrawer.addEventListener('click', function (e) {
          var item = e.target.closest('[data-line-key]');
          if (!item) return;
          var key = item.getAttribute('data-line-key');

          if (e.target.closest('[data-fcm-remove]')) {
            changeLine(key, 0).then(function (cart) {
              renderCart(cart, cartDrawer);
            });
            return;
          }

          var qtyBtn = e.target.closest('[data-fcm-qty]');
          if (qtyBtn) {
            var delta = Number(qtyBtn.getAttribute('data-fcm-qty'));
            var current = Number(item.querySelector('.fcm-cart-drawer__qty span').textContent);
            var next = Math.max(0, current + delta);
            changeLine(key, next).then(function (cart) {
              renderCart(cart, cartDrawer);
            });
          }
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !cartDrawer.hasAttribute('hidden')) {
            closeCart(cartDrawer, cartOpenBtns[0]);
          }
        });
      }
    }

    function initAll() {
      document.querySelectorAll('.fcm-header').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      var header = e.target.querySelector('.fcm-header') || (e.target.classList && e.target.classList.contains('fcm-header') ? e.target : null);
      if (header) {
        delete header.dataset.fcmHeaderReady;
        initHeader(header);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fcm-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(root) {
      if (!root || root.dataset.fcmHeaderReady) return;
      root.dataset.fcmHeaderReady = 'true';

      var burger = root.querySelector('[data-fcm-header-burger]');
      var drawer = root.querySelector('[data-fcm-header-drawer]');
      if (!burger || !drawer) return;

      burger.addEventListener('click', function () {
        var isOpen = !drawer.hasAttribute('hidden');
        if (isOpen) {
          drawer.setAttribute('hidden', '');
          burger.setAttribute('aria-expanded', 'false');
          burger.setAttribute('aria-label', 'Open menu');
        } else {
          drawer.removeAttribute('hidden');
          burger.setAttribute('aria-expanded', 'true');
          burger.setAttribute('aria-label', 'Close menu');
        }
      });
    }

    function initAll() {
      document.querySelectorAll('.fcm-header').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      var header = e.target.querySelector('.fcm-header') || (e.target.classList && e.target.classList.contains('fcm-header') ? e.target : null);
      if (header) {
        delete header.dataset.fcmHeaderReady;
        initHeader(header);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fcm-product-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProduct(root) {
      if (!root || root.dataset.fcmProductReady) return;
      root.dataset.fcmProductReady = 'true';

      var jsonEl = root.querySelector('[data-fcm-product-json]');
      var product = null;
      try {
        product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      } catch (e) {
        product = null;
      }

      var mainImage = root.querySelector('[data-fcm-main-image]') || root.querySelector('.fcm-product__main-image');
      var thumbs = root.querySelectorAll('[data-fcm-thumb]');
      var form = root.querySelector('[data-fcm-product-form]');
      var variantInput = root.querySelector('[data-fcm-variant-id]');
      var priceEl = root.querySelector('[data-fcm-product-price]');
      var addBtn = root.querySelector('[data-fcm-add-to-cart]');
      var buyNowBtn = root.querySelector('[data-fcm-buy-now]');
      var statusEl = root.querySelector('[data-fcm-product-status]');
      var optionSelects = root.querySelectorAll('[data-fcm-option]');
      var qtyInput = root.querySelector('[data-fcm-qty-input]');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImage) {
            mainImage.src = thumb.getAttribute('data-media-src');
            mainImage.srcset = thumb.getAttribute('data-media-srcset') || '';
            mainImage.alt = thumb.getAttribute('data-media-alt') || '';
          }
          if (typeof thumb.scrollIntoView === 'function') {
            thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
          }
        });
      });

      root.querySelectorAll('[data-fcm-qty-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var delta = Number(btn.getAttribute('data-fcm-qty-btn'));
          var next = Math.max(1, (Number(qtyInput.value) || 1) + delta);
          qtyInput.value = String(next);
        });
      });

      function getSelectedOptions() {
        var selected = [];
        optionSelects.forEach(function (sel) {
          selected[Number(sel.getAttribute('data-index'))] = sel.value;
        });
        return selected;
      }

      function findVariant(options) {
        if (!product || !product.variants) return null;
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === options[i];
          });
        }) || null;
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
        }
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: (product && product.currency) || 'USD'
          }).format(Number(cents) / 100);
        } catch (e) {
          return '$' + (Number(cents) / 100).toFixed(2);
        }
      }

      function updateVariant(variant) {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;

        if (priceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML =
              '<span class="fcm-product__price-sale">' + formatMoney(variant.price) + '</span>' +
              '<span class="fcm-product__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
          } else {
            priceEl.innerHTML =
              '<span class="fcm-product__price-current">' + formatMoney(variant.price) + '</span>';
          }
        }

        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-default-label') || 'Add to cart';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold out';
          }
        }
        if (buyNowBtn) {
          buyNowBtn.disabled = !variant.available;
        }
      }

      if (addBtn) {
        addBtn.setAttribute('data-default-label', addBtn.textContent.trim());
      }

      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var variant = findVariant(getSelectedOptions());
          updateVariant(variant);
        });
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!addBtn || addBtn.disabled) return;

          var formData = new FormData(form);
          addBtn.disabled = true;
          if (statusEl) {
            statusEl.textContent = 'Adding…';
            statusEl.classList.remove('is-success', 'is-error');
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add failed');
              return res.json();
            })
            .then(function () {
              if (statusEl) {
                statusEl.textContent = 'Added to cart';
                statusEl.classList.add('is-success');
              }
              addBtn.disabled = false;

              // Open cart drawer if present
              var openBtn = document.querySelector('[data-fcm-cart-open]');
              if (openBtn) openBtn.click();

              // Refresh cart count badges
              return fetch('/cart.js').then(function (r) { return r.json(); });
            })
            .then(function (cart) {
              if (!cart) return;
              document.querySelectorAll('[data-fcm-cart-count]').forEach(function (el) {
                el.textContent = String(cart.item_count);
                if (cart.item_count > 0) el.removeAttribute('hidden');
                else el.setAttribute('hidden', '');
              });
            })
            .catch(function () {
              if (statusEl) {
                statusEl.textContent = 'Could not add to cart. Please try again.';
                statusEl.classList.add('is-error');
              }
              addBtn.disabled = false;
            });
        });

        if (buyNowBtn) {
          buyNowBtn.addEventListener('click', function () {
            if (buyNowBtn.disabled) return;

            var formData = new FormData(form);
            buyNowBtn.disabled = true;
            if (addBtn) addBtn.disabled = true;
            if (statusEl) {
              statusEl.textContent = 'Redirecting to checkout…';
              statusEl.classList.remove('is-success', 'is-error');
            }

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData
            })
              .then(function (res) {
                if (!res.ok) throw new Error('Add failed');
                return res.json();
              })
              .then(function () {
                window.location.href = '/checkout';
              })
              .catch(function () {
                if (statusEl) {
                  statusEl.textContent = 'Could not start checkout. Please try again.';
                  statusEl.classList.add('is-error');
                }
                buyNowBtn.disabled = false;
                if (addBtn) addBtn.disabled = false;
              });
          });
        }
      }
    }

    function initAll() {
      document.querySelectorAll('[data-fcm-product]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      var section = e.target.querySelector('[data-fcm-product]') ||
        (e.target.matches && e.target.matches('[data-fcm-product]') ? e.target : null);
      if (section) {
        delete section.dataset.fcmProductReady;
        initProduct(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
